<span
  class="tooltip-info"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <button
    type="button"
    class="tooltip-trigger"
    [attr.aria-label]="ariaLabel"
    [attr.aria-expanded]="isOpen"
    (click)="onToggle($event)"
  >
    i
  </button>

  <span class="tooltip-bubble" role="tooltip" *ngIf="isOpen">
    {{ text }}
  </span>
</span>
